<template>
	<div class="section">
		<div class="container">
			<div class="columns is-multiline">
				<div class="column is-12">
					<h1 class="title is-1">Purchase subscription to the AWG Carbon Calculator</h1>
				</div>
				<div class="column is-12" v-if="!$store.getters.user.IsGroupManager">
					<p>Please contact your group manager(s) listed below to purchase access to this application.</p>
					<ul v-for="m in managers">
						<li> {{ m.Name }} - {{ m.Email }}</li>
					</ul>
				</div>
				<div class="column is-12" v-if="$store.getters.user.IsGroupManager">
					<div class="block" v-show="!loading">

					</div>

					<div class="columns is-multiline" v-show="!loading">
						<div class="column is-6">
							<p>Please select the time period you would like to purchase:</p>
							<b-field>
								<b-radio v-model="tab" @input="ChangeCart" name="monthly" native-value="monthly">Monthly - $750 per month</b-radio>
							</b-field>
							<b-field>
								<b-radio v-model="tab" @input="ChangeCart" name="yearly" native-value="yearly">Yearly - $5,000 per year</b-radio>
							</b-field>
						</div>
						<div class="column is-6">
							<p>
								<paypal v-model="paypal" :products="products" :plan="planId" @complete="FinishCheckout"></paypal>
							</p>
						</div>
					</div>
					<br />
					<p>Each subscription will automatically renew at the end of the relevant subscription period, unless the subscription is cancelled on the website. Non-AWG members can change or cancel their subscription at any time but such change or cancellation will only take effect at the end of the current subscription period.</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				paypal: undefined,
				tab: 'yearly',
				products: [{ amount: { value: '5000.00', currency_code: "USD" }, name: 'Carbon Calculator Access' }],
				product: undefined,
				planId: process.env.VUE_APP_PRODUCT_PLAN_YEARLY,
				loading: false,
				managers: []
			}
		},
		methods: {
			async FinishCheckout(data) {
				//console.log("paypal data", data);
				//https://developer.paypal.com/docs/business/javascript-sdk/javascript-sdk-reference/#onapprove
				//data contains the object in: https://developer.paypal.com/docs/api/orders/v2/#orders-capture-response
				try {
					await this.$http.post("/api/payment/paid", { userId: this.$store.getters.user.Id, planId: this.planId, orderResponse: data });
					await this.$refreshToken();
					this.$router.push({ name: "Thankyou" });
				}
				catch (err) {

				}
			},
			SelectMonthly() {
				this.$set(this, "planId", process.env.VUE_APP_PRODUCT_PLAN_MONTHLY);

				var price = 750;
				this.$set(this.products, "0", { amount: { value: price.toString(), currency_code: "USD" }, name: 'Carbon Calculator Access', custom_id: this.$store.getters.user.Id });
			},
			SelectYearly() {
				this.$set(this, "planId", process.env.VUE_APP_PRODUCT_PLAN_YEARLY);

				var price = 5000;
				this.$set(this.products, "0", { amount: { value: price.toString(), currency_code: "USD" }, name: 'Carbon Calculator Access', custom_id: this.$store.getters.user.Id });
			},
			ChangeCart(tab) {
				if (tab == "monthly")
					this.SelectMonthly();
				else if (tab == "yearly")
					this.SelectYearly();
			}
		},
		created() {
			this.SelectYearly();

			if (!this.$store.getters.user.IsGroupManager) {
				this.$http.get("api/authentication/groupManager")
					.then(resp => {
						this.managers = resp.data;
					}).catch(err => {
						console.error(err)
					})
			}
		}
	}
</script>
